import { ErrorKey } from '../app-active-error/ErrorKey';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { setError } from '../store/error/action-creators';
const LOG = Logger.getLogger('wordpressAuthorization');
export const handleWordpressAuthorizationError = (error = {
  message: ''
}, dispatch) => {
  LOG.error('Wordpress Authorization failed.', {
    extra: getSentryExtra(error)
  });
  dispatch(setError(ErrorKey.WordpressAuthorizationError, error));
};